import { Injectable,NgModule } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';
@Injectable()
export class ecommerceService {
    user:any;
  constructor(private http: HttpClient,private _global:Globals) {
    
  }
  readonly rootUrl = this._global.siteUrl;
  addcategory(categoryObj){
    return this.http.post(this.rootUrl + 'ecommcategory/addcategory', categoryObj);
  }
  categorylist(Obj){
    return this.http.post(this.rootUrl + 'ecommcategory/getcategorylist', Obj);
  }
  editcategory(id){
    const body={
      id:btoa(id),
    }
    return this.http.post(this.rootUrl+'ecommcategory/getcategory',body);
  }
  updatecategory(categoryObj){
    return this.http.post(this.rootUrl + 'ecommcategory/updatecategory', categoryObj);
  }
  delcategory(Id){
    const body = {
     id: Id,
     isDeleted:1
   }
   return this.http.post(this.rootUrl + 'ecommcategory/delcategory', body);
  }
}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/ecommerce.service.ts